export const faqItems = [
  {
    q: '古古漫画网真的完全免费吗？需要注册吗？',
    a: '是的！古古漫画网所有漫画均免费阅读，无需注册登录，打开网站即可畅享全集下拉式阅读。我们通过品牌合作维持运营，承诺永久向读者免费开放。不设付费墙、不需要积分，真正做到零门槛看漫画。',
  },
  {
    q: '什么是下拉式阅读？和传统翻页有什么区别？',
    a: '下拉式阅读将整话漫画以纵向长图形式呈现，手指下滑即可连续阅读，无需逐页点击翻页按钮。相比传统翻页模式，下拉式阅读更流畅、更沉浸，特别适合手机竖屏追漫。你可以在设置中自由切换下拉式和翻页式两种阅读模式。',
  },
  {
    q: '古古漫画网收录了哪些类型的漫画？更新频率如何？',
    a: '我们涵盖日漫、韩漫、国漫三大品类，细分标签超过 40 种，包括热血、恋爱、耽美、悬疑、奇幻、搞笑、校园、都市、古风、科幻等。热门连载漫画每日同步更新，新番上架最快两小时内完成，每周有超过 2000 话新内容入库。',
  },
  {
    q: '漫画画质怎么样？支持哪些设备阅读？',
    a: '所有漫画均为高清图源，部分热门作品提供超清版本。古古漫画网采用响应式设计，完美适配手机、平板和电脑端。手机端阅读体验经过专门优化，支持夜间模式、字号调节和横竖屏切换，保护你的双眼。',
  },
  {
    q: '如何发现更多好看的漫画？有没有推荐功能？',
    a: '你可以通过首页的搜索栏搜索漫画名称或作者，也可以浏览热门话题标签、人气排行榜、分类索引等模块来发现新作品。编辑团队每日精选高分漫画推荐，还会根据季节和热点推出主题专题，帮你找到心仪的漫画。',
  },
];

export const carouselItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20Japanese%20manga%20action%20battle%20scene%20with%20samurai%20and%20supernatural%20elements%2C%20warm%20orange%20and%20crimson%20color%20palette%2C%20dramatic%20energy%20effects%2C%20bold%20Japanese%20comic%20linework%2C%20epic%20composition%20with%20motion%20blur%2C%20modern%20digital%20manga%20illustration%2C%20high%20contrast%20dramatic%20lighting%2C%20cinematic%20anime%20art%20style&width=800&height=500&seq=gugu-carousel-01&orientation=landscape',
    title: '热血战斗季·燃爆一夏',
    desc: '精选百部高分热血战斗漫画，从经典神作到新番黑马，每一部都让你肾上腺素飙升',
    tag: '热血',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Romantic%20manga%20scene%20with%20two%20characters%20under%20cherry%20blossom%20trees%2C%20soft%20warm%20pastel%20pink%20and%20golden%20lighting%2C%20dreamy%20atmosphere%2C%20gentle%20Japanese%20comic%20art%20style%2C%20flowing%20hair%20and%20petals%2C%20tender%20emotional%20moment%2C%20clean%20minimalist%20background%2C%20high%20quality%20digital%20anime%20illustration&width=800&height=500&seq=gugu-carousel-02&orientation=landscape',
    title: '恋爱甜宠·心动特辑',
    desc: '高甜预警！最新甜宠恋爱漫画合集，从校园初恋到都市虐恋，治愈你的每一个日常',
    tag: '恋爱',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Full%20color%20Korean%20webtoon%20manhwa%20style%20illustration%2C%20modern%20stylish%20characters%20in%20trendy%20urban%20fashion%2C%20warm%20golden%20hour%20city%20background%2C%20clean%20digital%20art%20with%20smooth%20gradients%2C%20sophisticated%20color%20palette%20with%20coral%20and%20amber%20tones%2C%20professional%20webtoon%20quality%2C%20romantic%20contemporary%20aesthetic&width=800&height=500&seq=gugu-carousel-03&orientation=landscape',
    title: '韩漫精选·全彩盛宴',
    desc: '全彩条漫精选推荐，从都市情感到奇幻冒险，韩流漫画一站收录，画风精美到每一格',
    tag: '韩漫',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20fantasy%20cultivation%20scene%20with%20majestic%20ancient%20Chinese%20architecture%20and%20floating%20mountains%2C%20ink%20wash%20painting%20influence%2C%20warm%20vermilion%20and%20gold%20color%20palette%2C%20detailed%20flowing%20robes%2C%20dramatic%20atmospheric%20mist%20and%20clouds%2C%20modern%20digital%20manhua%20quality%2C%20epic%20mythological%20composition&width=800&height=500&seq=gugu-carousel-04&orientation=landscape',
    title: '国漫崛起·东方幻想',
    desc: '国风仙侠、都市异能、古风玄幻，见证国产漫画的崛起之路，每一部都是文化自信',
    tag: '国漫',
  },
];

export const commentItems = [
  {
    name: '漫迷小陈',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20young%20male%20avatar%20portrait%2C%20friendly%20warm%20smile%2C%20simple%20cream%20background%2C%20clean%20digital%20illustration%2C%20soft%20natural%20lighting%2C%20approachable%20character%20design&width=80&height=80&seq=gugu-avatar-01&orientation=squarish',
    time: '刚刚',
    content: '在这里追了三年漫画了，从《鬼灭》到《咒术》，下拉式阅读真的比翻页舒服太多，一口气看几十话完全不累！更新速度也快得离谱，推荐给了身边所有漫友。古古漫画网，我的精神食粮。',
    manga: '《咒术回战》',
  },
  {
    name: '二次元少女',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20young%20female%20avatar%20portrait%2C%20cheerful%20bright%20expression%2C%20simple%20warm%20background%2C%20clean%20digital%20illustration%2C%20soft%20diffused%20lighting%2C%20cute%20character%20design&width=80&height=80&seq=gugu-avatar-02&orientation=squarish',
    time: '2 小时前',
    content: '最喜欢的漫画网站没有之一！分类特别全，日漫韩漫国漫都有，每天中午准时刷新看更新。完全没有广告弹窗和强制跳转，阅读体验太纯净了。古古漫画网 yyds！',
    manga: '《某天成为公主》',
  },
  {
    name: '熬夜追漫人',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20teenage%20male%20avatar%20portrait%2C%20casual%20relaxed%20expression%2C%20simple%20warm%20background%2C%20clean%20digital%20illustration%2C%20soft%20studio%20lighting%2C%20modern%20character%20design&width=80&height=80&seq=gugu-avatar-03&orientation=squarish',
    time: '5 小时前',
    content: '韩漫全彩的画风真的绝了，古古的韩漫库应该是全网最全的吧，从《我独自升级》到《全知读者视角》，每一部都追得停不下来。下拉式阅读看全彩条漫简直完美适配！',
    manga: '《我独自升级》',
  },
  {
    name: '国漫铁粉',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20female%20avatar%20portrait%20with%20glasses%2C%20gentle%20intellectual%20smile%2C%20simple%20warm%20background%2C%20clean%20digital%20illustration%2C%20soft%20natural%20lighting%2C%20elegant%20character%20design&width=80&height=80&seq=gugu-avatar-04&orientation=squarish',
    time: '8 小时前',
    content: '国漫这几年进步太大了！古古的国漫专区整理得特别好，从《一人之下》到《镇魂街》，每部都是高清画质。古风仙侠专区更是宝藏，看一集就停不下来。',
    manga: '《一人之下》',
  },
  {
    name: '日漫老读者',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20adult%20male%20avatar%20portrait%2C%20calm%20mature%20expression%2C%20simple%20warm%20background%2C%20clean%20digital%20illustration%2C%20soft%20ambient%20lighting%2C%20sophisticated%20character%20design&width=80&height=80&seq=gugu-avatar-05&orientation=squarish',
    time: '12 小时前',
    content: '从大学追到工作，古古漫画网陪伴了我六年。下拉式阅读这个设计真的太懂读者了，比那些翻页站点好用一百倍。日漫区的经典作品收录很全，老漫迷的快乐老家。',
    manga: '《海贼王》',
  },
];

export const updateItems = [
  {
    time: '刚刚',
    title: '《咒术回战》第 263 话「终局的序章」已更新',
    desc: '虎杖与宿傩的最终决战进入白热化阶段，五条悟的遗志将由谁来继承？',
    tag: '日漫',
  },
  {
    time: '28 分钟前',
    title: '《我独自升级》外传第 12 话上线',
    desc: '全新剧情线展开，讲述主角成振宇在成为最强猎人之前的过往秘辛',
    tag: '韩漫',
  },
  {
    time: '1 小时前',
    title: '《一人之下》第 658 话热更中',
    desc: '宝儿姐身世之谜即将揭晓，异人界的势力格局发生重大变化',
    tag: '国漫',
  },
  {
    time: '2 小时前',
    title: '新作《深海之瞳》第 1 话重磅首发',
    desc: '原创奇幻悬疑新连载，开局即高能，画风炸裂，首话好评如潮',
    tag: '国漫',
  },
  {
    time: '4 小时前',
    title: '《间谍过家家》第 98 话更新',
    desc: '安妮亚的校园冒险继续，佛杰一家的温馨日常让人会心一笑',
    tag: '日漫',
  },
  {
    time: '6 小时前',
    title: '《全知读者视角》第 215 话',
    desc: '金独子面临最终抉择，灭活法的真相逐渐浮出水面，剧情迎来高潮',
    tag: '韩漫',
  },
  {
    time: '8 小时前',
    title: '《镇魂街》第三季第 45 话',
    desc: '曹焱兵七大守护灵全部觉醒，与王国组织的终局之战正式打响',
    tag: '国漫',
  },
];

export const rankingItems = [
  {
    rank: 1,
    title: '我独自升级',
    type: '韩漫',
    heat: '986 万热度',
    desc: 'E 级猎人逆袭之路，全球现象级韩漫神作，全网热度第一',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20art%20style%2C%20dark%20fantasy%20hunter%20theme%2C%20single%20powerful%20character%20silhouette%20with%20glowing%20purple%20and%20blue%20effects%2C%20dramatic%20lighting%2C%20warm%20amber%20accent%20tones%2C%20clean%20minimal%20composition%2C%20professional%20manhwa%20quality%2C%20solo%20leveling%20inspired%20aesthetic&width=240&height=320&seq=gugu-rank-01&orientation=portrait',
  },
  {
    rank: 2,
    title: '咒术回战',
    type: '日漫',
    heat: '852 万热度',
    desc: '咒术师与诅咒的巅峰对决，芥见下下现象级代表作',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20cover%20art%20style%2C%20supernatural%20dark%20fantasy%20battle%20theme%2C%20character%20with%20mysterious%20markings%20in%20dynamic%20pose%2C%20dark%20atmosphere%20with%20warm%20orange%20flame%20accents%2C%20bold%20linework%2C%20clean%20digital%20manga%20illustration%2C%20jujutsu%20kaisen%20inspired%20aesthetic&width=240&height=320&seq=gugu-rank-02&orientation=portrait',
  },
  {
    rank: 3,
    title: '一人之下',
    type: '国漫',
    heat: '768 万热度',
    desc: '异人世界道法传承，中国漫画里程碑之作，国漫之光',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20art%20style%2C%20taoist%20supernatural%20martial%20arts%20theme%2C%20warm%20golden%20and%20vermilion%20tones%2C%20ink%20wash%20influence%2C%20dynamic%20character%20with%20flowing%20energy%2C%20modern%20digital%20Chinese%20illustration%2C%20majestic%20atmospheric%20composition&width=240&height=320&seq=gugu-rank-03&orientation=portrait',
  },
  {
    rank: 4,
    title: '全知读者视角',
    type: '韩漫',
    heat: '725 万热度',
    desc: '小说成为现实，唯一知晓结局之人的末世生存战',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20style%2C%20fantasy%20apocalypse%20theme%2C%20mysterious%20character%20holding%20a%20glowing%20book%2C%20warm%20golden%20and%20amber%20light%2C%20clean%20minimal%20digital%20art%2C%20omniscient%20reader%20inspired%2C%20soft%20atmospheric%20glow&width=240&height=320&seq=gugu-rank-04&orientation=portrait',
  },
  {
    rank: 5,
    title: '间谍过家家',
    type: '日漫',
    heat: '691 万热度',
    desc: '间谍父亲+杀手母亲+超能力女儿，最温馨的家庭喜剧',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20cover%20style%2C%20heartwarming%20spy%20family%20comedy%20theme%2C%20three%20characters%20in%20elegant%20poses%2C%20soft%20warm%20beige%20and%20coral%20color%20palette%2C%20clean%20minimal%20illustration%2C%20gentle%20charming%20atmosphere%2C%20spy%20x%20family%20inspired%20aesthetic&width=240&height=320&seq=gugu-rank-05&orientation=portrait',
  },
  {
    rank: 6,
    title: '镇魂街',
    type: '国漫',
    heat: '653 万热度',
    desc: '人灵共存的奇幻世界，守护灵战斗燃爆全场',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20style%2C%20supernatural%20guardian%20spirit%20battle%20theme%2C%20ancient%20warrior%20aesthetic%2C%20dramatic%20fiery%20vermilion%20and%20gold%20composition%2C%20bold%20dynamic%20digital%20illustration%2C%20epic%20mythological%20atmosphere&width=240&height=320&seq=gugu-rank-06&orientation=portrait',
  },
];

export const indexItems = [
  { title: '热血战斗', count: '3,825 部', icon: 'ri-sword-line', desc: '燃到爆炸的战斗漫画合集' },
  { title: '恋爱甜宠', count: '4,210 部', icon: 'ri-heart-line', desc: '甜到心坎的恋爱物语' },
  { title: '奇幻冒险', count: '3,658 部', icon: 'ri-compass-3-line', desc: '异世界与魔法的大冒险' },
  { title: '悬疑推理', count: '1,892 部', icon: 'ri-search-eye-line', desc: '烧脑悬疑漫画精选' },
  { title: '搞笑日常', count: '2,934 部', icon: 'ri-emotion-laugh-line', desc: '笑到停不下来的日常' },
  { title: '都市异能', count: '2,456 部', icon: 'ri-flashlight-line', desc: '现代都市的超能英雄' },
  { title: '古风仙侠', count: '3,102 部', icon: 'ri-moon-clear-line', desc: '国风修仙玄幻漫画' },
  { title: '耽美纯爱', count: '5,678 部', icon: 'ri-star-smile-line', desc: '唯美纯爱漫画专区' },
  { title: '恐怖惊悚', count: '1,234 部', icon: 'ri-ghost-line', desc: '胆大就来挑战恐怖漫画' },
];

export const cardItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20action%20scene%20with%20samurai%20demon%20slayer%20theme%2C%20dramatic%20battle%20composition%20in%20warm%20orange%20and%20crimson%20tones%2C%20bold%20Japanese%20linework%2C%20dynamic%20sword%20movement%20with%20fire%20effects%2C%20clean%20modern%20manga%20aesthetic%2C%20cinematic%20lighting%20and%20atmosphere%2C%20high%20quality%20digital%20illustration&width=600&height=400&seq=gugu-card-01&orientation=landscape',
    title: '《鬼灭之刃》全集',
    desc: '灶门炭治郎的灭鬼之旅，现象级热血神作完整收录，剧场版无限列车篇同步上线',
    tag: '日漫·热血',
    status: '已完结',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20fantasy%20scene%20with%20elegant%20royal%20palace%20interior%2C%20full%20color%20digital%20manhwa%20style%2C%20warm%20golden%20and%20rose%20tones%2C%20beautiful%20princess%20character%20design%2C%20soft%20dreamy%20ethereal%20atmosphere%2C%20high%20quality%20webtoon%20illustration%2C%20romantic%20period%20aesthetic&width=600&height=400&seq=gugu-card-02&orientation=landscape',
    title: '《某天成为公主》',
    desc: '穿越成为公主扭转命运，画风绝美的韩漫经典，全网点击超过 50 亿次',
    tag: '韩漫·恋爱',
    status: '连载中',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20fantasy%20cultivation%20comedy%20scene%2C%20ancient%20Chinese%20temple%20and%20mountain%20landscape%2C%20ink%20wash%20painting%20style%20with%20modern%20digital%20rendering%2C%20warm%20golden%20and%20vermilion%20accents%2C%20humorous%20character%20expression%2C%20majestic%20yet%20playful%20atmosphere%2C%20high%20quality%20digital%20Chinese%20illustration&width=600&height=400&seq=gugu-card-03&orientation=landscape',
    title: '《大王饶命》',
    desc: '灵气复苏时代的最强吐槽王，爆笑修仙国漫代表作，每一话都是笑点密集',
    tag: '国漫·搞笑',
    status: '连载中',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20manga%20scene%20with%20chainsaw%20devil%20hunter%20theme%2C%20mysterious%20shadowy%20atmosphere%2C%20Japanese%20comic%20style%20with%20gritty%20texture%2C%20dramatic%20chiaroscuro%20lighting%2C%20warm%20amber%20highlights%20through%20darkness%2C%20intricate%20detailed%20linework%2C%20suspenseful%20mood%2C%20professional%20dark%20digital%20art&width=600&height=400&seq=gugu-card-04&orientation=landscape',
    title: '《电锯人》全集',
    desc: '藤本树颠覆性神作，暗黑热血与荒诞幽默的完美融合，不可错过的现象级作品',
    tag: '日漫·暗黑',
    status: '第一部完',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Colorful%20Chinese%20manhua%20modern%20urban%20fantasy%20scene%2C%20stylish%20characters%20with%20supernatural%20powers%20in%20futuristic%20city%2C%20warm%20golden%20evening%20lighting%2C%20dynamic%20action%20composition%2C%20clean%20digital%20illustration%20style%20with%20smooth%20gradients%2C%20high%20quality%20rendering%2C%20sci-fi%20adventure%20aesthetic&width=600&height=400&seq=gugu-card-05&orientation=landscape',
    title: '《星海镖师》',
    desc: '宇宙冒险科幻国漫，热血少年跨越星辰的成长史诗，连载十年口碑之作',
    tag: '国漫·科幻',
    status: '连载中',
  },
];

export const mediaItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Manga%20review%20channel%20style%20video%20thumbnail%2C%20top%20manga%20ranking%20theme%2C%20warm%20inviting%20orange%20and%20gold%20color%20palette%2C%20professional%20layout%20with%20engaging%20visual%20composition%2C%20clean%20modern%20design%2C%20anime%20manga%20aesthetic%2C%20high%20quality%20thumbnail%20design&width=640&height=360&seq=gugu-media-01&orientation=landscape',
    title: '2024 年度漫画大赏 TOP10 出炉',
    author: '漫评人 · 阿风',
    duration: '15:28',
    views: '12.8 万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Latest%20manga%20chapter%20analysis%20video%20thumbnail%2C%20jujutsu%20kaisen%20discussion%20theme%2C%20warm%20amber%20and%20crimson%20color%20tones%2C%20engaging%20visual%20layout%20with%20character%20silhouettes%2C%20clean%20professional%20design%2C%20anime%20discussion%20aesthetic%2C%20high%20quality%20thumbnail%20composition&width=640&height=360&seq=gugu-media-02&orientation=landscape',
    title: '《咒术回战》最终章逐格深度解析',
    author: '漫评人 · 小北',
    duration: '22:15',
    views: '9.6 万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Hidden%20gem%20manga%20recommendation%20video%20thumbnail%2C%20discovery%20and%20treasure%20hunt%20theme%2C%20warm%20coral%20and%20cream%20color%20palette%2C%20clean%20inviting%20design%20with%20book%20stack%20visual%2C%20minimalist%20cozy%20layout%2C%20reading%20aesthetic%2C%20high%20quality%20thumbnail%20art&width=640&height=360&seq=gugu-media-03&orientation=landscape',
    title: '冷门神作挖掘：这 5 部漫画你必须看',
    author: '漫评人 · 橙子',
    duration: '18:42',
    views: '7.3 万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20industry%20analysis%20video%20thumbnail%2C%20professional%20discussion%20theme%2C%20warm%20golden%20and%20rich%20vermilion%20tones%2C%20clean%20modern%20layout%20with%20elegant%20design%2C%20cultural%20pride%20aesthetic%2C%20high%20quality%20professional%20composition%2C%20documentary%20style%20thumbnail&width=640&height=360&seq=gugu-media-04&orientation=landscape',
    title: '国漫崛起深度分析：从模仿到创新',
    author: '漫评人 · 大鱼',
    duration: '25:30',
    views: '5.9 万',
  },
];

export const featureItems = [
  {
    icon: 'ri-scroll-to-bottom-line',
    title: '下拉式阅读',
    desc: '告别翻页，一滑到底。整话漫画无缝衔接，给你最流畅的沉浸式阅读体验，特别为手机竖屏深度优化。',
  },
  {
    icon: 'ri-global-line',
    title: '三漫合一',
    desc: '日漫、韩漫、国漫三大品类一站收录，从经典黑白连载到全彩条漫，你想看的类型这里全都有。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速更新',
    desc: '与汉化组及内容平台同步，热门连载每日更新，新番上架最快两小时内完成，永不错过任何精彩。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '纯净阅读',
    desc: '无弹窗广告、无强制跳转，沉浸式纯净阅读环境。支持夜间模式和字号调节，用心呵护你的双眼。',
  },
];

export const topicItems = [
  { name: '热血漫画', heat: '128 万讨论' },
  { name: '恋爱漫画', heat: '96 万讨论' },
  { name: '韩漫推荐', heat: '85 万讨论' },
  { name: '国漫崛起', heat: '79 万讨论' },
  { name: '漫画新番', heat: '73 万讨论' },
  { name: '下拉式阅读', heat: '65 万讨论' },
  { name: '完结神作', heat: '58 万讨论' },
  { name: '奇幻冒险', heat: '52 万讨论' },
  { name: '耽美漫画', heat: '48 万讨论' },
  { name: '漫画改编', heat: '41 万讨论' },
];

export const navLinks = [
  { label: '首页', href: '#hero' },
  { label: '热门话题', href: '#topics' },
  { label: '人气榜单', href: '#ranking' },
  { label: '分类索引', href: '#index' },
  { label: '读者热议', href: '#comments' },
  { label: '客户端阅读', href: '#app' },
  { label: '漫评解说', href: '#media' },
];

export const heroStats = [
  { value: '20,000+', label: '部漫画收录' },
  { value: '每日 300+', label: '话实时更新' },
  { value: '100%', label: '免费全本阅读' },
];